import { Theme, lighten } from "@mui/material";

const styles = {
  root: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "primary.main",
    zIndex: 100,
    width: "64px",
  },
  active: (theme: Theme) => ({
    backgroundColor: lighten(theme.palette.primary.main, 0.25),
    borderRadius: "5px",
  }),
  icon: {
    fontSize: 18,
    py: 1,
    px: 0.5,
    color: "white",
  },
  link: { textDecoration: "none" },
  iconText: {
    fontSize: 9,
    fontWeight: 600,
    color: "white",
    textDecoration: "none",
  },
};

export default styles;
